export default "__VITE_ASSET__aca75cd7__"